import { useGetEmbeddedURL } from '@/hooks';

export const Report = () => {
  const { data: embeddedURL, isLoading, error: embeddedURLError } = useGetEmbeddedURL();

  const renderErrorMessage = () => {
    if (!embeddedURLError) return null;

    if ((embeddedURLError as any)?.data?.code === 'FORBIDDEN') {
      return (
        <div className="mt-4 w-full max-w-5xl rounded-lg border border-yellow-300 bg-yellow-50 p-4 text-yellow-800">
          You don’t currently have permission to view these reports. Please contact your system administrator at
          <span className="font-medium"> awmssupportteam@curtin.edu.au</span> to request access.
        </div>
      );
    }

    return <div className="text-red-500">Failed to load the report. Please try again later.</div>;
  };

  return (
    <div className="flex h-full w-screen flex-col items-start overflow-auto bg-white py-0">
      <div className="w-screen px-8">
        <div className="mt-2 text-5xl font-bold leading-[60px]">Reports</div>
        <div className="mt-2 text-base">
          This section displays the key academic workload insights via QuickSight dashboards. If you have access to
          specific reports, they will load below.
        </div>

        <div className="mt-12">
          {isLoading && <div className="text-gray-500">Loading report...</div>}
          {renderErrorMessage()}
          {!isLoading && embeddedURL && (
            <div className="h-[800px] w-full overflow-hidden rounded-xl border border-gray-300 shadow">
              <iframe
                src={embeddedURL.embedUrl}
                className="h-full w-full"
                frameBorder="0"
                allowFullScreen
                title="QuickSight Dashboard"
              ></iframe>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
